import {useEffect, useState} from 'react'

/**
 * True from the first time `isOpen` is true onwards. Lets an overlay stay
 * unmounted until it is needed, then stay mounted so its close animation runs.
 */
const useHasOpened = (isOpen) => {
    const [hasOpened, setHasOpened] = useState(false)

    useEffect(() => {
        if (isOpen && !hasOpened) setHasOpened(true)
    }, [isOpen, hasOpened])

    return isOpen || hasOpened
}

export default useHasOpened
